import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CalendarOptions, EventClickArg, EventDropArg, EventInput, EventSourceInput } from '@fullcalendar/core';
import { EditRecurringEventsDialogComponent, EventAddComponent, EventUpdateComponent, FilterCalendarDialogComponent, HarvestAddComponent, HarvestGroupDeleteComponent, RestrictionNotificationComponent, UsersAssignComponent } from 'app/dialogs';
import dayGridPlugin from '@fullcalendar/daygrid';
import listPlugin from '@fullcalendar/list';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin, { DateClickArg } from '@fullcalendar/interaction';
import { AppStorage } from 'app/services';

import * as models from 'app/models';
import * as services from 'app/services';
import * as viewmodels from 'app/viewmodels';
import { DeviceDetectorService } from 'ngx-device-detector';
import { FullCalendarComponent } from '@fullcalendar/angular';
import { EventApi } from '@fullcalendar/core';

import { Calendar } from '@fullcalendar/core';
import bootstrap5Plugin from '@fullcalendar/bootstrap5';
import { forkJoin, Subscription } from 'rxjs';
import { CollectionReference, DocumentData, QuerySnapshot, Timestamp } from '@angular/fire/firestore';
import { MatSelectChange } from '@angular/material/select';
import { FilterSectionComponent } from '../filter-section/filter-section.component';
import { AngularFirestoreCollection } from '@angular/fire/compat/firestore';
import { onSnapshot, Unsubscribe } from 'firebase/firestore';

@Component({
    selector: 'app-calendar-five',
    templateUrl: './calendar-five.component.html',
    styleUrls: ['./calendar-five.component.scss'],
    standalone: false
})
export class CalendarFiveComponent implements OnInit, OnDestroy {

  @ViewChild('calendar') calendarComponent: FullCalendarComponent;
  @ViewChild(FilterSectionComponent) filterSectionComponent: FilterSectionComponent;

  onlyMyTasks: boolean = false;
  //filterUserId: string = undefined;
  filterUserIds: string[];
  filterTeamId: string = undefined;
  filterTeamIds: string[];
  completeStatus: string = 'both';
  phases: string[] = [];
  tags: string[] = [];
  zoneIds: string[] = [];
  filteredHarvestPhasesByZone: viewmodels.HarvestPhases[];

  users: Array<models.User> = [];
  retrievedUsers: boolean = false;
  teams: Array<models.Team> = [];
  retrievedTeams: boolean = false;

  harvestIds: Array<string> = [];
  harvests: Array<models.Harvest> = [];
  groupIds: Array<string> = [];

  zones: Array<models.Zone> = [];

  companySub: Subscription;
  harvestEventSubs: Array<EventSubscription> = [];
  groupEventSubs: Array<EventSubscription> = [];
  helperSub: Subscription;
  events: models.Event[] = [];

  viewType: string = 'dayGridMonth';
  viewStart: Date;
  viewEnd: Date;

  get canSeeHarvestAdd(): boolean {
    return this.claimsService.userRole?.permissions?.includes(models.Permissions.addHarvest);
  }

  get canSeeGroupAdd(): boolean {
    return this.claimsService.userRole?.permissions?.includes(models.Permissions.addGroup);
  }

  get canSeeMassUserAssign(): boolean {
    return this.claimsService.userRole?.permissions?.includes(models.Permissions.assignUsers);
  }

  get canSeeHarvestGroupDelete(): boolean {
    return this.claimsService.userRole?.permissions?.includes(models.Permissions.addHarvest) ||
           this.claimsService.userRole?.permissions?.includes(models.Permissions.addGroup);
  }

  async canDragEvents(): Promise<boolean> {
    return (await this.claimsService.getRoleAwait())?.permissions?.includes(models.Permissions.editEvent);
  }

  get canSeeAddEventBtn(): boolean {
    return this.claimsService.userRole?.permissions?.includes(models.Permissions.addEvent);
  }

  get canSeeWeeklyListSlider(): boolean {
    if (this.viewType == 'listWeek' || this.viewType == 'dayGridWeek') {
      return true;
    }
    return false;
  }

  get calendarEvents(): EventSubscription[] {
    // let harvestEvents = this.harvestEventSubs.map(i => i.calendarEvents).flat();
    // let groupEvents = this.groupEventSubs.map(i => i.calendarEvents).flat();

    let eventLists = [...this.harvestEventSubs, ...this.groupEventSubs];

    eventLists.forEach(list => {
      this.filterEventList(list);
    });

    return eventLists;
  }

  filterEventList(list: EventSubscription) {
    let events = list.allEvents;

    if (this.onlyMyTasks) {
      events = events.filter(i => 
        (i.eventObj.assignedUserIds != null && 
        i.eventObj.assignedUserIds.includes(this.claimsService.currentUserId())) ||
        (i.eventObj.assignedTeamIds != null && 
        i.eventObj.assignedTeamIds.filter(value => this.filterTeamIds.includes(value)).length > 0)
      )
    }

    //filter by user
    if(this.filterUserIds != null && this.filterUserIds.length > 0) {
      events = events.filter(i => 
        (i.eventObj.assignedUserIds != null && 
        i.eventObj.assignedUserIds.filter(value => this.filterUserIds.includes(value)).length > 0) ||
        (i.eventObj.assignedTeamIds != null && 
        i.eventObj.assignedTeamIds.filter(value => this.filterTeamIds.includes(value)).length > 0)
      )
    }

    //filter by team
    if(this.filterTeamIds != null && this.filterTeamIds.length > 0) {
      events = events.filter(i => 
        (i.eventObj.assignedTeamIds != null && 
        i.eventObj.assignedTeamIds.filter(value => this.filterTeamIds.includes(value)).length > 0)
      )
    }

    //filter by phases
    if (this.phases != null && this.phases.length > 0) {
      events = events.filter(i => this.phases.includes(i.eventObj.phase))
    }

    //filter by tags
    if (this.tags != null && this.tags.length > 0) {
      events = events.filter(i => i.eventObj.tags != null && i.eventObj.tags.filter(value => this.tags.includes(value)).length > 0)
    }

    //filter by zone
    if (this.zoneIds != null && this.zoneIds.length > 0) {
      let foundHarvestPhases = this.filteredHarvestPhasesByZone.find(i => i.harvestId == list.id);
      if(foundHarvestPhases == null){
        events = [];
      } else {
        events = events.filter(i => foundHarvestPhases.phases?.includes(i.eventObj.phase))
      }
    }

    //filter by completed status
    if (this.completeStatus != null) {
      switch (this.completeStatus) {
        case 'incomplete':
          events = events.filter(i => i.eventObj.completed == false)
          break;
        case 'complete':
          events = events.filter(i => i.eventObj.completed == true)
          break;
        case 'both':
        default:
          events = events;
      }
    }
    
    list.events = events;
  }

  calendarOptions: CalendarOptions = {
    initialView: 'dayGridMonth',
    plugins: [dayGridPlugin, listPlugin, timeGridPlugin, interactionPlugin],
    //themeSystem: 'bootstrap5',
    //themeSystem: 'bootstrap',
    dateClick: this.addEvent.bind(this),
    views: {
      dayGridMonth: { buttonText: this.deviceService.isMobile() ? 'm' : 'month' },
      dayGridWeek: {
        buttonText: this.deviceService.isMobile() ? 'w' : 'week',
        eventLimit: 20
      },
      listDay: { buttonText: this.deviceService.isMobile() ? 'd' : 'day' },
      //timeGridWeek: { buttonText: this.deviceService.isMobile() ? 'W3' : 'Week3' },
      listWeek: { buttonText: this.deviceService.isMobile() ? 'w' : 'week' }
    },
    headerToolbar: {
      left: 'title',
      //center: 'title',
      right: 'today dayGridMonth,listWeek,listDay prev,next'
    },
    eventClick: this.eventClick.bind(this),
    height: 'auto',
    //eventStartEditable: await this.canDragEvents(),
    eventDrop: this.eventDrop.bind(this),
    eventSources: this.calendarEvents,
    eventOrder: this.eventOrder.bind(this),
    //eventContent: this.eventContent.bind(this),
    eventClassNames: this.eventClassName.bind(this),
    datesSet: this.datesSet.bind(this),
    eventDisplay: 'list-item',
    dayMaxEventRows: 12,
    //eventContent: this.eventContent.bind(this)
    eventTextColor: 'black',
  }

  get gettingEvents() {
    let incompleteHarvest = this.harvestEventSubs.filter(i => !i.completedInitialGet);
    let incompleteGroup = this.groupEventSubs.filter(i => !i.completedInitialGet);

    return incompleteHarvest.length != 0 || incompleteGroup.length != 0
  }

  hasSetEvents: boolean = false;
  setCalendarEvents(sub: EventSubscription = null) {
    if (!this.gettingEvents) {
      this.events = [...this.harvestEventSubs.filter(i => i.eventList != null).map(i => i.eventList).flat(), ...this.groupEventSubs.filter(i => i.eventList != null).map(i => i.eventList).flat()];
      if(!this.hasSetEvents){
        this.calendarOptions.eventSources = this.calendarEvents;
        this.hasSetEvents = true;
        return;
      }

      let calendarApi = this.calendarComponent.getApi();
      let allEventSubs: Array<EventSubscription> = [];

      if(sub == null){
        allEventSubs = this.calendarEvents;

        //remove all sources that aren't in this list
        let eventSources = calendarApi.getEventSources();
        let sourcesToRemove = eventSources.filter(i => !this.calendarEvents.map(j => j.id).includes(i.id));
        sourcesToRemove.forEach(source => {
          source.remove();
        })
      } else {
        allEventSubs.push(sub);
      }

      allEventSubs.forEach(sub => {
        let eventSource = calendarApi.getEventSourceById(sub.id);
        if(eventSource != null){
          eventSource.remove();
        } 

        this.filterEventList(sub);
        calendarApi.addEventSource(sub);
      });
    }
  }

  constructor(
    private claimsService: services.ClaimsService
    , private dialog: MatDialog
    , private helperService: services.HelperService
    , private appStorage: AppStorage
    , private deviceService: DeviceDetectorService
    , private eventService: services.EventService
    , private userService: services.UserService
    , private teamService: services.TeamService
    , private harvestService: services.HarvestService
    , private groupService: services.GroupService
    , private notifierService: services.NotifierService
    , private zoneService: services.ZoneService
    , private calendarService: services.CalendarService
    , private filterSetService: services.FilterSetService
  ) { }

  async ngOnInit() {
    //get companyId
    let companyId = this.helperService.currentCompanyId;

    //if we have it then load
    if (companyId != null) {
      this.initialLoad(companyId);
    }

    //set up subscription to listen to company id changes
    this.companySub = this.helperService.getCurrentCompanyId().subscribe(data => {
      this.hasSetEvents = false;
      this.initialLoad(data);
    })

    this.calendarOptions.eventStartEditable = await this.canDragEvents();
    //this.weeklyListView = this.appStorage.weeklyListView;

    this.helperSub = this.calendarService.sub.subscribe(data => {
      this.initialLoad(this.helperService.currentCompanyId)
    });
  }

  ngOnDestroy() {
    if (this.companySub != null) {
      this.companySub.unsubscribe();
    }

    this.harvestEventSubs.forEach(sub => {
      sub.sub();
    });
    this.harvestEventSubs = [];
    this.groupEventSubs.forEach(sub => {
      sub.sub();
    });
    this.groupEventSubs = [];

    if(this.helperSub != null){
      this.helperSub.unsubscribe();
    }
  }

  async initialLoad(companyId: string) {
    this.users = await this.userService.getUsersForCompanyWithCaching(companyId, true, true)
    this.retrievedUsers = true;

    this.teams = await this.getTeams()
    this.retrievedTeams = true;

    let calls = [
      this.harvestService.getAll(true).get().toPromise(),
      this.groupService.getAll().get().toPromise(),
      this.zoneService.getAll()
    ]

    forkJoin(calls).subscribe((data: any) => {
      let harvestResponse: QuerySnapshot<DocumentData> = data[0];
      this.harvestIds = harvestResponse.docs.map(i => i.id);
      let harvests = [];
      harvestResponse.docs.forEach(h => {
        let harvest: models.Harvest = h.data();
        harvest.uid = h.id;
        harvests.push(harvest);
      });
      this.harvests = harvests;

      let groupResponse: QuerySnapshot<DocumentData> = data[1];
      this.groupIds = groupResponse.docs.map(i => i.id);

      this.zones = data[2];

      this.load();
    })
  }

  async getTeams(): Promise<models.Team[]> {
    let teams: models.Team[] = [];
    let teamResponse = await (await this.teamService.getAll().get()).toPromise()
    teamResponse.docs.forEach(doc => {
        let team: models.Team = doc.data();
        team.uid = doc.id;
        teams.push(team);
      })
    return teams;
  }

  filter() {
    let calendarFilter = {
      initialHarvestIds: this.harvestIds,
      initialGroupIds: this.groupIds,
      selectedUserId: this.filterUserIds[0],
      selectedTeamId: this.filterTeamId,
      completeStatus: this.completeStatus,
      onlyMyTasks: this.onlyMyTasks,
      phases: this.phases,
      tags: this.tags,
      zoneIds: this.zoneIds,
      events: [...this.harvestEventSubs.filter(i => i.eventList != null).map(i => i.eventList).flat(), ...this.groupEventSubs.filter(i => i.eventList != null).map(i => i.eventList).flat()]
    }
    let dialogRef = this.dialog.open(FilterCalendarDialogComponent, {
      data: calendarFilter
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.harvestIds = result.harvestIds;
        this.groupIds = result.groupIds;
        this.filterUserIds.push(result.selectedUserId);
        this.filterTeamId = result.selectedTeamId
        this.completeStatus = result.completeStatus;
        this.onlyMyTasks = result.onlyMyTasks;
        this.phases = result.phases;
        this.tags = result.tags;
        this.zoneIds = result.zoneIds;
        //this.filterUserIds = result.userIds;
        this.filterTeamIds = result.teamIds;

        this.load();
      }
    })
  }

  onFilter(result) {
    this.harvestIds = result.harvestIds;
    this.groupIds = result.groupIds;
    this.zoneIds = result.zoneIds;
    this.phases = result.phases;
    this.filterTeamIds = result.teamIds;
    this.filterUserIds = result.userIds;
    this.tags = result.tags
    this.completeStatus = result.completeStatus;
    this.onlyMyTasks = result.onlyMyTasks;

    this.hasSetEvents = false;
    this.load();
  }

  async load() {    
    if(this.zoneIds != null && this.zoneIds.length > 0) {
      console.log('This shouldnt be happening a lot')
      this.filteredHarvestPhasesByZone = await this.harvestService.getHarvestsAndPhasesByZoneIds(this.zoneIds);
    }
    this.compileHarvestSubscriptions();
    this.compileGroupSubscriptions();
  }

  compileHarvestSubscriptions() {
    this.harvestIds.forEach(harvestId => {
      let foundSub = this.harvestEventSubs.find(i => i.id == harvestId)
      if (foundSub == null) {
        let sub = this.getEvents(harvestId, 'harvest');
        let newSub: EventSubscription = {
          id: harvestId,
          sub: sub,
          events: [],
          allEvents: [],
          completedInitialGet: false
        }
        this.harvestEventSubs.push(newSub);
      }
    });

    let subscriptionsToRemove: Array<EventSubscription> = this.harvestEventSubs.filter(i => !this.harvestIds.includes(i.id));
    this.harvestEventSubs = this.unsubscribeAndRemove(subscriptionsToRemove, this.harvestEventSubs);
    this.setCalendarEvents();
  }

  compileGroupSubscriptions() {
    this.groupIds.forEach(groupId => {
      let foundSub = this.groupEventSubs.find(i => i.id == groupId)
      if (foundSub == null) {
        let sub = this.getEvents(groupId, 'group');
        let newSub: EventSubscription = {
          id: groupId,
          sub: sub,
          events: [],
          allEvents: [],
          completedInitialGet: false
        }
        this.groupEventSubs.push(newSub);
      }
    });

    let subscriptionsToRemove: Array<EventSubscription> = this.groupEventSubs.filter(i => !this.groupIds.includes(i.id));
    this.groupEventSubs = this.unsubscribeAndRemove(subscriptionsToRemove, this.groupEventSubs);
    this.setCalendarEvents();
  }

  unsubscribeAndRemove(subsToRemove: Array<EventSubscription>, currentSubs: Array<EventSubscription>) {
    subsToRemove.forEach(sub => {
      sub.sub();
    });
    let ids: string[] = subsToRemove.map(i => i.id);
    return currentSubs.filter(i => !ids.includes(i.id));
  }

  getEvents(id: string, type: string): Unsubscribe {
    let call: CollectionReference<DocumentData>;
    if (type == 'harvest') {
      call = this.eventService.get(id);
    } else if (type == 'group') {
      call = this.eventService.getFromGroup(id);
    } else {
      return;
    }
    return onSnapshot(call, (snapshot) => {
      console.log(snapshot.docs.length);
      if (snapshot.docs.length == 0) {
        if (type == 'harvest') {
          this.harvestEventSubs = this.unsubscribeAndRemove(this.harvestEventSubs.filter(i => i.id == id), this.harvestEventSubs);
        } else if (type == 'group') {
          this.groupEventSubs = this.unsubscribeAndRemove(this.groupEventSubs.filter(i => i.id == id), this.groupEventSubs);
        }
        this.setCalendarEvents();
        return;
      }
      snapshot.forEach(element => {
        let dbEventObj: any = element.data();
        let list: Array<models.Event> = dbEventObj.list;

        let eventSub: EventSubscription;

        if (type == 'harvest') {
          eventSub = this.harvestEventSubs.find(i => i.id == id);
        } else if (type == 'group') {
          eventSub = this.groupEventSubs.find(i => i.id == id);
        } else {
          return;
        }

        eventSub.eventListId = element.id;
        eventSub.eventList = list;

        let calendarEvents: Array<any> = []

        list.forEach((dbevent, index) => {
          // //if filterUserId is definied then we need to only display the events that pertain to that id
          // if (this.filterUserId !== undefined) {
          //   if (dbevent.assignedUserIds == null || !dbevent.assignedUserIds.includes(this.filterUserId)) {
          //     return;
          //   }
          // }

          //set the color and completed value of the event
          let color: string = dbevent.color;
          let className: string = '';
          if (dbevent.completed) {
            className = 'completed'
          }
          if (dbevent.highPriority && !dbevent.completed) {
            className += ' high-priority';
          }
          if (type == 'group') {
            className += ' task-group-event';
          }

          //get zone identifier
          let zoneIdentifier = null;
          if (type == 'harvest' && this.zones.length > 0) {
            let zoneIds = this.getZoneIds(id, dbevent.phase);
            let zones = this.zoneService.getAllTopLevel(this.zones, zoneIds);
            zoneIdentifier = zones.map(i => i.name).join(', ');
          }

          //get the title of the event
          let title: string = `${type == 'harvest' ? dbevent.harvestName : dbevent.groupName}${zoneIdentifier != null && zoneIdentifier != '' ? ' (' + zoneIdentifier + ') ': ''}: ${dbevent.description}`;
          //if the assigned team ids is not empty or null
          if (dbevent.assignedTeamIds !== undefined && dbevent.assignedTeamIds.length !== 0) {
            title = `${title} - Teams: `;

            const teams = this.teams.filter(i => (dbevent.assignedTeamIds ?? []).includes(i.uid)).map(i => i.name);
            
            title += this.helperService.concatToSentence(teams);
          }
          //if the assigned user ids is not empty or null
          if (dbevent.assignedUserIds !== undefined && dbevent.assignedUserIds.length !== 0) {
            title = `${title} - Users: `;

            const users = this.users.filter(i => (dbevent.assignedUserIds ?? []).includes(i.id)).map(i => i.displayName);
            
            title += this.helperService.concatToSentence(users);
          }

          let event: EventInput = {
            title: title,
            date: dbevent.startDateTime.toDate(),
            allDay: dbevent.anyTime !== false,
            color: color,
            className: className,
            eventObj: dbevent,
            type: type,
            parentId: id
          }

          calendarEvents.push(event);
        });


        eventSub.events = calendarEvents;
        eventSub.allEvents = calendarEvents;
        eventSub.completedInitialGet = true;
        this.setCalendarEvents(eventSub);
      });
    });
  }

  getZoneIds(id: string, phase: string) {
    let zoneIds: string[] = [];
    let harvest = this.harvests.find(i => i.uid == id);
    if(harvest == null){
      return zoneIds;
    }
    let currentPhase = harvest.phases?.find(i => i.phaseName == phase);
    if(currentPhase?.strains == null){
      return zoneIds;
    }
    currentPhase.strains.forEach(strain => {
      if(strain.zones == null){
        return;
      }
      strain.zones.forEach(zone => {
        if(!zoneIds.includes(zone.zoneId)){
          zoneIds.push(zone.zoneId);
        }
      });
    });

    return zoneIds;
  }

  async canAdd() {
    let harvestResponse = await this.harvestService.getAll(false).get().toPromise();
    if (this.helperService.company_freeVersion && harvestResponse.size >= this.appStorage.freeHarvests) {
      return false;
    }
  }

  addHarvest() {
    if (!this.canAdd()) {
      let restrictionDialog = this.dialog.open(RestrictionNotificationComponent, {
        data: 'harvestAdd'
      });
      return;
    }

    let dialogRef = this.dialog.open(HarvestAddComponent, {
      data: { addGroup: false }
    });

    dialogRef.afterClosed().subscribe(result => {
      //reload list
      if (result) {
        this.harvestIds.push(result);
        //need to get new group in filter
        this.filterSectionComponent.harvestsChanged(this.harvestIds);
        this.compileHarvestSubscriptions();
      }
      console.log(JSON.stringify(result));
    })
  }

  addGroup() {
    let dialogRef = this.dialog.open(HarvestAddComponent, {
      data: { addGroup: true }
    });

    dialogRef.afterClosed().subscribe(result => {
      //reload list
      if (result) {
        this.groupIds.push(result);
        //need to get new group in filter
        this.filterSectionComponent.groupsChanged(this.groupIds);
        this.compileGroupSubscriptions();
      }
      console.log(JSON.stringify(result));
    })
  }

  addEvent(arg: DateClickArg) {
    if(!this.claimsService.userRole?.permissions?.includes(models.Permissions.addEvent)){
      return;
    }

    let data: any = {}
    if (this.viewType == 'listDay') {
      data.date = this.viewStart;
    } else if (arg != null) {
      data.date = arg.date
    }
    let dialogRef = this.dialog.open(EventAddComponent, {
      panelClass: 'med-width-dialog',
      data: data,
      autoFocus: true
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result && result.save) {
        //perform save
        let assignToGroup: boolean = result.assignToGroup;
        let harvest: models.Harvest = result.harvest;
        let group: models.Group = result.group;

        let events: Array<models.Event> = result.events;
        let dbEvents: Array<models.Event> = [];

        events.forEach(event => {
          let dbEvent: models.Event = event;

          dbEvent.color = assignToGroup ? group.color : harvest.color;

          if (assignToGroup) {
            delete dbEvent.harvestName;
            dbEvent.groupName = group.name;
          } else {
            delete dbEvent.groupName;
            dbEvent.harvestName = harvest.name;
          }

          dbEvents.push(dbEvent);
        });

        await this.eventService.add(assignToGroup, assignToGroup ? group.uid : harvest.uid, dbEvents);
      }
      console.log(JSON.stringify(result));
    })
  }

  usersMassAssign() {
    this.dialog.open(UsersAssignComponent);
  }

  harvestGroupDelete() {
    let dialogRef = this.dialog.open(HarvestGroupDeleteComponent);

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        let harvestIdsToRemove: string[] = result.harvestIds;
        let groupIdsToRemove: string[] = result.groupIds;
  
        this.harvestIds = this.harvestIds.filter(i => !harvestIdsToRemove.includes(i))
        this.groupIds = this.groupIds.filter(i => !groupIdsToRemove.includes(i))
        this.filterSectionComponent.harvestsChanged(this.harvestIds)
        this.filterSectionComponent.groupsChanged(this.groupIds)
        this.load();
      }
    })
  }

  eventClick(arg: EventClickArg) {
    let start = arg.event.start;
    let type = arg.event._def.extendedProps.type;
    let parentId = arg.event._def.extendedProps.parentId;

    let harvestId;
    let groupId;
    if (type == 'harvest') {
      harvestId = parentId;
    } else if (type == 'group') {
      groupId = parentId;
    } else {
      return;
    }
    let assignToGroup: boolean = false;
    if (harvestId == null && groupId != null) {
      assignToGroup = true;
    }

    let foundSub: EventSubscription;

    if (harvestId) {
      foundSub = this.harvestEventSubs.find(i => i.id == harvestId);
    } else if (groupId) {
      foundSub = this.groupEventSubs.find(i => i.id == groupId);
    }

    let data: any = {
      event: arg.event._def.extendedProps.eventObj,
      start: start,
      assignToGroup: assignToGroup,
      eventList: foundSub.eventList
    }

    if (assignToGroup) {
      data.groupId = groupId
    } else {
      data.harvestId = harvestId
    }

    let dialogRef = this.dialog.open(EventUpdateComponent, {
      width: '800px',
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result) {
        return;
      }
      if (result.save) {
        //perform save
        let dbEvent: models.DbEvent = {
          uid: foundSub.eventListId,
          list: result.eventList
        }
        this.eventService.save(assignToGroup, foundSub.id, dbEvent);
      }
      else if (result.delete) {
        let list: models.Event[] = result.eventList;
        let index = list.indexOf(result.event);

        if (index > -1) {
          result.eventList.splice(index, 1);
        }

        let dbEvent: models.DbEvent = {
          uid: foundSub.eventListId,
          list: result.eventList
        }
        this.eventService.save(assignToGroup, foundSub.id, dbEvent);

      }
      console.log(JSON.stringify(result));
    })
  }

  eventDrop(arg: EventDropArg) {
    let event: models.Event = arg.event._def.extendedProps.eventObj
    let type = arg.event._def.extendedProps.type;
    let parentId = arg.event._def.extendedProps.parentId;
    let start = arg.event.start;

    //find if it is recurring event
    if (event.repeatedEventId != null && event.repeatedEventId != '') {

      let dialogRef = this.dialog.open(EditRecurringEventsDialogComponent, {
        autoFocus: true,
        disableClose: false
      });

      dialogRef.afterClosed().subscribe(async result => {
        //reload list
        if (result) {
          this.updateEvent(event, result, start, type, parentId)
          //alert('save all now - ' + result);
        } else {
          arg.revert()
        }
        console.log(result);
      })
    } else {
      this.updateEvent(event, 'one', start, type, parentId);
    }

  }

  updateEvent(event: models.Event, recurringDescission: string, start: Date, type: any, parentId: string) {
    let harvestId;
    let groupId;
    if (type == 'harvest') {
      harvestId = parentId;
    } else if (type == 'group') {
      groupId = parentId;
    } else {
      return;
    }
    let assignToGroup: boolean = false;
    if (harvestId == null && groupId != null) {
      assignToGroup = true;
    }

    let foundSub: EventSubscription;

    if (harvestId) {
      foundSub = this.harvestEventSubs.find(i => i.id == harvestId);
    } else if (groupId) {
      foundSub = this.groupEventSubs.find(i => i.id == groupId);
    }

    let diff: number = Timestamp.fromDate(start).seconds - event.startDateTime.seconds;

    switch (recurringDescission) {
      case 'following':
        let applicableFollowingEvents = foundSub.eventList.filter(i => i.repeatedEventId == event.repeatedEventId &&
          i.startDateTime >= event.startDateTime);
        for (let i = 0; i < applicableFollowingEvents.length; i++) {
          const ev = applicableFollowingEvents[i];
          ev.startDateTime = new Timestamp(ev.startDateTime.seconds + diff, ev.startDateTime.nanoseconds)
        }
        break;
      case 'all':
        let applicableEvents = foundSub.eventList.filter(i => i.repeatedEventId == event.repeatedEventId);
        for (let i = 0; i < applicableEvents.length; i++) {
          const ev = applicableEvents[i];
          ev.startDateTime = new Timestamp(ev.startDateTime.seconds + diff, ev.startDateTime.nanoseconds)
        }
        break;
      case 'one':
      default:
        event.startDateTime = Timestamp.fromDate(start);
        break;
    }

    let dbEvent: models.DbEvent = {
      uid: foundSub.eventListId,
      list: foundSub.eventList
    }
    this.eventService.save(assignToGroup, foundSub.id, dbEvent);

    this.notifierService.success('Successfully saved new task date');
  }

  eventOrder(eventA, eventB) {
    if (eventA.eventObj.highPriority && !eventB.eventObj.highPriority) {
      return -1;
    }
    if (!eventA.eventObj.highPriority && eventB.eventObj.highPriority) {
      return 1;
    }

    if (eventA.allDay && !eventB.allDay) {
      return 1;
    }
    if (!eventA.allDay && eventB.allDay) {
      return -1;
    }

    if (eventA.start < eventB.start) {
      return -1;
    } else if (eventA.start > eventB.start) {
      return 1;
    }

    let precA: number = eventA.precedence ? eventA.precedence : 0;
    let precB: number = eventB.precedence ? eventB.precedence : 0;

    if (precB < precA) {
      return -1;
    } else if (precB > precA) {
      return 1;
    }

    eventB.title.localeCompare(eventA.title)

    if(eventA.title < eventB.title) { return -1; }
    if(eventA.title > eventB.title) { return 1; }

    return 0;
  }

  eventClassName(arg: any) {
    let c = [];
    let event: EventApi = arg.event;
    let eventObj: models.Event = event.extendedProps.eventObj;
    if (eventObj.highPriority) {
      c.push('high-priority');
    }
    if (eventObj.completed) {
      c.push('completed');
    }

    let applicableEvents = eventObj.discussions?.filter(i =>
      i.discussionType == models.DiscussionType.Note ||
      i.discussionType == models.DiscussionType.InitialNote ||
      i.discussionType == models.DiscussionType.AttachedFile) ?? [];

    let totalBadge = applicableEvents.length + (eventObj.cloudAttachments?.length ?? 0);

    if (totalBadge > 0) {
      c.push('cal-badge');

      switch (totalBadge) {
        case (1):
          c.push('one');
          break;
        case (2):
          c.push('two');
          break;
        case (3):
          c.push('three');
          break;
        case (4):
          c.push('four');
          break;
        case (5):
          c.push('five');
          break;
        case (6):
          c.push('six');
          break;
        case (7):
          c.push('seven');
          break;
        case (8):
          c.push('eight');
          break;
        case (9):
          c.push('nine');
          break;
        default:
          c.push('plus');
          break;
      }
    }
    return c;
  }

  eventContent(arg: any) {
    let event: EventApi = arg.event;
    let title = event.title;
    if (event.extendedProps.eventObj.highPriority) {
      title = '<i style="font-weight: bold;" class="fa fa-exclamation"></i>  ' + event.title;
    }

    return { html: title };
  }

  datesSet(dateInfo) {
    this.viewType = dateInfo.view.type;
    this.viewStart = dateInfo.start;
    this.viewEnd = dateInfo.end;

    if (this.viewType == 'listWeek' && !this.weeklyListView) {
      this.viewType = 'dayGridWeek';
      this.calendarComponent.getApi().changeView('dayGridWeek');
    }
  }

  weeklyListView: boolean = true;
  toggleListViewChange(newVal) {
    if (this.weeklyListView) {
      this.viewType = 'listWeek';
      this.calendarComponent.getApi().changeView('listWeek');
    } else {
      this.viewType = 'dayGridWeek';
      this.calendarComponent.getApi().changeView('dayGridWeek');
    }

    this.appStorage.weeklyListView = this.weeklyListView;
  }

}

interface EventSubscription {
  id: string;
  eventListId?: string;
  sub: Unsubscribe;
  events: EventInput[]; //filtered events - to display
  allEvents: EventInput[]; //all events in calendar format - unfiltered
  eventList?: Array<models.Event>; //all events in the model of what is in the system
  completedInitialGet?: boolean;
}